import React, { Component } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Col, Row, Tabs, Tab, Container } from 'react-bootstrap';
import ProjEditForm from './ProjEditForm';
import HashChange from "react-hashchange";
import QuestAdd from './quests/QuestAddApp.js';

class ProjectsEditApp extends React.Component {
    E_TYPE = {
        ALL: 0,
        SINGLE: 1
    };

    constructor(props) {
        super(props);
        Tools.init();
        API.init(this);

        this.state = {
            formData: null,
            isLoading: true,
            pid: this.props.match.params["id"]
        };

        console.log(this.state);

        if (this.state.pid) {
            this.getData(this.state.pid);
        } else {
            this.state.isLoading = false;
            this.state.formData = {};
        }
        this.getData = this.getData.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
        this.renderContent = this.renderContent.bind(this);
        this.handleOnUrlChange = this.handleOnUrlChange.bind(this);
        this.onCopy = this.onCopy.bind(this);
        this.onDel = this.onDel.bind(this);
        this.onDownloadMember = this.onDownloadMember.bind(this);
        this.onDownloadRecord = this.onDownloadRecord.bind(this);
        this.onDownloadQuestion = this.onDownloadQuestion.bind(this);
    }

    getProjID(hash) {
        const hashList = hash.match(/\/proj\/edit\/(.*)/);
        console.log("!!", hash);
        if (hashList && hashList.length >= 2) return hashList[1];
        return null;
    }

    handleOnUrlChange = (data) => {
        const pid = this.getProjID(data.hash);

        console.log("pid", pid);
        if (pid) {
            this.setState({
                pid: pid
            });
            this.getData(pid);
        } else {
            this.setState({
                pid: pid,
                formData: {}
            });
        }
    }

    getData(pid) {
        console.log(pid, this);
        if (!pid) return;

        API.GetProjectByID({
            ty: 1, //0=該帳號下全部專案, 1=單⼀一專案
            pi: pid
        })
            .then(response => {
                console.log(response);
                this.setState({
                    isLoading: false,
                });

                if (response && response.responseData) {
                    if (response.responseData.data) {
                        let proj = response.responseData.data[0];
                        this.setState({ formData: proj });
                    }
                }
            }) // JSON from `response.json()` call
            .catch(error => console.error(error)); //head, body
    }

    onUpdate(data) {
        console.log(data);
        if (null == data) return;
        let p_typeParse = parseInt(data.p_type);
        if (isNaN(p_typeParse)) {
            alert("請選擇問卷類型");
            return;
        }

        // if(data.p_type) data.p_type = parseInt(data.p_type);

        //interval type
        if (data.p_type == 2) {
            if (!data.interval_year) data.interval_year = 0;
            if (!data.interval_month) data.interval_month = 0;
            if (!data.interval_day) data.interval_day = 0;
        }

        this.setState({
            isLoading: true
        });

        API.AddProject({
            ty: 2,
            pi: this.state.pid
        }, data)
            .then(response => {
                console.log(response);

                if (response && response.responseData) {
                    console.log(response.responseData.code);
                    if (response.responseData.code == "22000") {
                        this.getData(this.state.pid);
                    } else {
                        alert(response.responseData.msg);
                        this.setState({
                            isLoading: false
                        });
                    }
                }
            }) // JSON from `response.json()` call
            .catch(error => console.error(error)); //head, body
    }


    onCopy() {
        console.log("onCopy");

    }

    onDel() {
        console.log("onDel");
    }

    onDownloadMember() {
        console.log("onDownloadMember");
        API.GetAnswerMemberCSV({
            pi: this.state.pid
        }).then(response => {
            console.log(response);

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(response.responseData);
            link.download = "GetAnswerMemberCSV.csv";
            link.click();
        }) // JSON from `response.json()` call
            .catch(error => console.error(error));
    }

    onDownloadRecord() {
        console.log("onDownloadRecord");
        API.GetAnswerRecordCSV({
            pi: this.state.pid
        }).then(response => {
            console.log(response);

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(response.responseData);
            link.download = "GetAnswerRecordCSV.csv";
            link.click();
        }) // JSON from `response.json()` call
            .catch(error => console.error(error));
    }

    onDownloadQuestion() {
        console.log("onDownloadQuestion");
        API.GetQuestionOptionsCSV({
            pi: this.state.pid
        }).then(response => {
            console.log(response);

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(response.responseData);
            link.download = "GetQuestionOptionsCSV.csv";
            link.click();
        }) // JSON from `response.json()` call
            .catch(error => console.error(error));
    }


    renderContent() {
        const { isLoading, formData } = this.state;
        const { onUpdate,
            onCopy,
            onDel,
            onDownloadMember,
            onDownloadRecord,
            onDownloadQuestion } = this;

        console.log(formData);
        if (isLoading) {
            return (
                <div className="h1 mx-auto text-center my-5">Loading..</div>
            );
        } else {
            return (
                <>
                    <h2 className="mt-3 mb-3">{"專案:" + (formData ? formData.name : "undefined")}</h2>
                    <Tabs defaultActiveKey="data" id="uncontrolled-tab-example">
                        <Tab eventKey="data" title="專案資料">
                            <ProjEditForm
                                formData={formData}
                                onUpdate={onUpdate}
                                onCopy={onCopy}
                                onDel={onDel}
                                onDownloadMember={onDownloadMember}
                                onDownloadRecord={onDownloadRecord}
                                onDownloadQuestion={onDownloadQuestion}
                            />
                        </Tab>
                        <Tab eventKey="content" title="問卷編輯">
                            <QuestAdd pi={this.state.pid} />
                        </Tab>
                        {/* <Tab eventKey="order" title="跳題邏輯">
                            跳題邏輯TBD
                        </Tab> */}
                    </Tabs>
                </>
            );
        }
    }

    render() {
        const { handleOnUrlChange, renderContent } = this;
        return (
            <HashChange onChange={handleOnUrlChange} render={renderContent} />
        );
    }
}

const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ProjectsEditApp))